import { createSelector } from '@reduxjs/toolkit';

import favoritesSelector from './favorites';

const optionsSelector = createSelector(favoritesSelector, favorites => favorites.options);

export default optionsSelector;
